/**
 * TabHaslo — Zakładka "Hasło klucza" — zapis/usunięcie hasła do klucza prywatnego.
 *
 * Refaktor 2026-06-01: hasło wyodrębnione z TabCertyfikat na osobną zakładkę.
 *
 * Props:
 *   - adminConfig (object)
 *   - savedNip (string)
 *   - onSaved (callback)
 */
import { Lock } from "lucide-react";
import { KeyPasswordForm } from "../components/KeyPasswordForm";

export const TabHaslo = ({ adminConfig, savedNip, onSaved }) => {
  const needsCert = !adminConfig?.has_cert;
  const needsKey = !adminConfig?.key_filename;
  const blocking = !savedNip || needsCert || needsKey;

  return (
    <div className="space-y-4" data-testid="tab-haslo">
      {blocking ? (
        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg space-y-1">
          <p className="text-sm text-yellow-800 font-medium">
            Najpierw zapisz NIP, certyfikat i klucz prywatny
          </p>
          <ul className="text-xs text-yellow-700 ml-4 list-disc">
            {!savedNip && <li>Brak NIP podmiotu — zakładka "Podmiot"</li>}
            {needsCert && <li>Brak pliku certyfikatu — zakładka "Pliki cert/klucz"</li>}
            {needsKey && <li>Brak pliku klucza prywatnego — zakładka "Pliki cert/klucz"</li>}
          </ul>
        </div>
      ) : (
        <>
          <div className="mb-2">
            <div className="flex items-center gap-2 mb-1">
              <Lock className="w-4 h-4 text-gray-500" />
              <h3 className="text-sm font-semibold text-gray-700">Hasło do klucza prywatnego</h3>
            </div>
            <p className="text-xs text-gray-500">
              Hasło zostanie zaszyfrowane AES-256 i zapisane w bazie. Po zapisaniu
              backend sprawdzi czy hasło odblokowuje zapisany klucz (zapobiega
              cichym błędom podczas synchronizacji KSeF).
            </p>
          </div>

          <KeyPasswordForm adminConfig={adminConfig} onSaved={onSaved} />
        </>
      )}
    </div>
  );
};

export default TabHaslo;
